/**
 * TheSportsDB usa nombres en inglés; el Excel de selecciones/calendario usa códigos FIFA
 * (MEX, CAN, BIH, KOR…). El emparejamiento del sync se hace por código, no por nombre en español.
 */
export function normalizeApiTeamName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ç/g, 'c')
    .replace(/\./g, '')
    .replace(/\s+y\s+/g, ' ')
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Nombre en TheSportsDB (normalizado) → código FIFA del Excel. */
export const THESPORTSDB_TEAM_TO_FIFA_CODE: Record<string, string> = {
  algeria: 'ALG',
  argentina: 'ARG',
  australia: 'AUS',
  austria: 'AUT',
  belgium: 'BEL',
  'bosnia herzegovina': 'BIH',
  brazil: 'BRA',
  cameroon: 'CMR',
  canada: 'CAN',
  'cape verde': 'CPV',
  chile: 'CHI',
  china: 'CHN',
  colombia: 'COL',
  'costa rica': 'CRC',
  croatia: 'CRO',
  curacao: 'CUW',
  'czech republic': 'CZE',
  denmark: 'DEN',
  ecuador: 'ECU',
  egypt: 'EGY',
  'el salvador': 'SLV',
  england: 'ENG',
  france: 'FRA',
  germany: 'GER',
  ghana: 'GHA',
  haiti: 'HAI',
  honduras: 'HON',
  iran: 'IRN',
  italy: 'ITA',
  'ivory coast': 'CIV',
  jamaica: 'JAM',
  japan: 'JPN',
  mexico: 'MEX',
  morocco: 'MAR',
  netherlands: 'NED',
  nigeria: 'NGA',
  panama: 'PAN',
  paraguay: 'PAR',
  peru: 'PER',
  poland: 'POL',
  portugal: 'POR',
  qatar: 'QAT',
  'saudi arabia': 'KSA',
  scotland: 'SCO',
  senegal: 'SEN',
  serbia: 'SRB',
  'south africa': 'RSA',
  'south korea': 'KOR',
  spain: 'ESP',
  sweden: 'SWE',
  switzerland: 'SUI',
  tunisia: 'TUN',
  turkey: 'TUR',
  ukraine: 'UKR',
  uruguay: 'URU',
  usa: 'USA',
  'united states': 'USA',
  'united arab emirates': 'UAE',
};

export function getFifaCodeFromApiTeam(apiTeamName: string): string | null {
  const normalized = normalizeApiTeamName(apiTeamName);
  const direct = THESPORTSDB_TEAM_TO_FIFA_CODE[normalized];
  if (direct) return direct;

  const hyphenated = normalized.replace(/\s/g, '-');
  if (THESPORTSDB_TEAM_TO_FIFA_CODE[hyphenated]) {
    return THESPORTSDB_TEAM_TO_FIFA_CODE[hyphenated];
  }

  return null;
}

export function getPairCodeFingerprint(codeA: string, codeB: string): string {
  return [codeA.toUpperCase(), codeB.toUpperCase()].sort().join('::');
}
